(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbLabelNoError', fbLabelDirective);

    function fbLabelDirective() {
        return {
            restrict:'E',
            transclude:true,
            scope: {
                element: '='
            },
            templateUrl: 'common/libraries/formBuilder/fields/label-no-error',
            controller: fbLabelDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbLabelDirectiveCtrl($scope, FormBuilderService, lodash) {
        var vm = this;
    }
})();